import { onMounted, onUnmounted, computed } from 'vue';
import { useInterval } from '@vueuse/core';

// Pad to 2 or 3 digits, default is 2
const padZero = (num: number, numDigits: 2 | 3 = 2) =>
  ('00' + num).slice(-numDigits);

export function formatTime(
  timeMsec: number,
  type: 'sec' | 'min' | 'hour' = 'min',
) {
  if (isNaN(timeMsec)) return 'Err';
  switch (type) {
    case 'hour':
      return `${padZero((timeMsec / 3.6e6) | 0)}:${padZero(((timeMsec % 3.6e6) / 6e4) | 0)}:${padZero(((timeMsec % 6e4) / 1000) | 0)}`;
    case 'min':
      return `${padZero(((timeMsec % 3.6e6) / 6e4) | 0)}:${padZero(((timeMsec % 6e4) / 1000) | 0)}`;
    case 'sec':
      return `${padZero(((timeMsec % 6e4) / 1000) | 0)}`;
    default:
      return 'Err';
  }
}

export function useTimer() {
  const {
    counter,
    reset,
    pause: stop,
    resume: start,
  } = useInterval(100, { controls: true });

  const timeMiliseconds = computed(() => counter.value * 100);

  const timeSeconds = computed(() => {
    return counter.value / 10;
  });

  // let intervalId: number | null = null;

  // const start = () => {
  //   if (intervalId === null) {
  //     intervalId = window.setInterval(() => {
  //       timeMiliseconds.value += 100;
  //     }, 100);
  //   }
  // };

  const formattedTime = computed(() => {
    return formatTime(timeMiliseconds.value);
  });

  // const reset = () => {
  //   stop();
  //   timeMiliseconds.value = 0;
  // };

  onMounted(() => {
    reset();
    start();
  });

  onUnmounted(() => {
    reset();
    stop();
  });

  return {
    timeMiliseconds,
    timeSeconds,
    formattedTime,
    start,
    stop,
    reset,
  };
}
